import { useState } from 'react';
import '../css/ServiceCategories.css';
import useIdleLogout from "../hooks/useIdleLogout";
export default function ServiceCategories() {
    useIdleLogout();
  const [categories, setCategories] = useState([
    { id: 1, name: 'Transport', description: 'Taxi, bike, and delivery services' },
    { id: 2, name: 'Food', description: 'Restaurants, takeaways, and food delivery' },
    { id: 3, name: 'Logistics', description: 'Package and courier delivery' },
  ]);

  const [newName, setNewName] = useState('');
  const [newDesc, setNewDesc] = useState('');

  const addCategory = (e) => {
    e.preventDefault();
    if (!newName.trim() || !newDesc.trim()) return;
    setCategories([...categories, { id: Date.now(), name: newName, description: newDesc }]);
    setNewName('');
    setNewDesc('');
  };

  const deleteCategory = (id) => {
    setCategories(categories.filter((c) => c.id !== id));
  };

  return (
    <div className="service-categories-page">
      <div className="service-categories-center">
        <div className="service-card">
          <h2 className="section-title mb-2">Manage Service Categories</h2>
          <p className="text-muted mb-4">
            Add, edit, or remove service categories offered on the platform.
          </p>

          {/* Add Category Form */}
          <form className="row g-3 mb-4 align-items-end" onSubmit={addCategory}>
            <div className="col-md-4">
              <label className="form-label">Category Name</label>
              <input
                type="text"
                className="form-control"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder="e.g., Health"
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Description</label>
              <input
                type="text"
                className="form-control"
                value={newDesc}
                onChange={(e) => setNewDesc(e.target.value)}
                placeholder="Short description"
              />
            </div>
            <div className="col-md-2">
              <button type="submit" className="btn btn-primary w-100">
                Add Category
              </button>
            </div>
          </form>

          {/* Categories Table */}
          <div className="table-responsive">
            <table className="table category-table">
              <thead>
                <tr>
                  <th>SI.No</th>
                  <th>Category</th>
                  <th>Description</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((cat, idx) => (
                  <tr key={cat.id}>
                    <td>{idx + 1}</td>
                    <td>{cat.name}</td>
                    <td>{cat.description}</td>
                    <td>
                      <button className="btn btn-sm btn-warning me-2">Edit</button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => deleteCategory(cat.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <footer className="dashboard-footer">
        <small>© {new Date().getFullYear()} SuperApp Admin • All rights reserved</small>
      </footer>
    </div>
  );
}
